var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "myskov" }, [
    _c("div", { staticClass: "myskov__header" }, [
      _c("div", { staticClass: "myskov__header__content" }, [
        _c("h1", { domProps: { textContent: _vm._s(_vm.translations.title) } }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            img: "",
            src: require("./../../img/my-skov-rejser/myskov-plane.svg"),
            alt: ""
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "myskov__content" },
      [
        _c("myskov-menu", { attrs: { "is-logged-in": _vm.isLoggedIn } }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "my-skov-area" },
          [
            _vm.isLoginPage ? _c("login-box") : _vm._e(),
            _vm._v(" "),
            !_vm.isLoginPage ? _c("myskov-area") : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5685e70", { render: render, staticRenderFns: staticRenderFns })
  }
}